export default __webpack_public_path__ + "static/media/chevron-down-small.8bc8ccfb.svg";